<script>
import L from 'leaflet';
import shapeData from './ShapeData.geojson';
import rankHuyen from './ShapeRankHuyen.geojson';
import rankTinh from './ShapeDongThap.geojson';
import { LPopup } from 'vue2-leaflet';

export default {
    name: 'bando',
    components: {
        LPopup
    },
    data() {
        return {
            map: null,
            showModal: false,
            selectedFeatureName: '',
            selectedFeatureDetails: '',
            selectedFeatureTitle: '',
            selectedFeatureMota: '',
            selectedFeatureDaiDien: '',
            selectedFeatureAddress: '',
            selectedFeatureSdt: '',
            selectedFeatureSanPham: '',
            checkbox1: false,
            checkbox2: false,
            checkbox3: false,
            checkbox4: false,
            checkbox5: false,
            checkbox6: false,
            checkbox7: false,
            checkbox8: false,
            checkbox9: false,
            markers: [], // Danh sách marker
        };
    },
    mounted() {
        this.initMap();
        this.addShapeLayer();
    },
    watch: {
        // Theo dõi sự thay đổi của biến showMarkers
        showMarkers() {
            // Gọi hàm toggleMarkers mỗi khi showMarkers thay đổi
            this.toggleMarkers();
        }
    },
    methods: {
        initMap() {
            this.map = L.map(this.$refs.map, {
                minZoom: 2,
                maxZoom: 20,
                zoomSnap: 0.1,
            }).setView([10.472155, 105.570464], 9.4);
        },

        resetMap() {
            // Đặt lại tọa độ và mức zoom của bản đồ về giá trị ban đầu
            this.map.setView([10.472155, 105.570464], 9.4);
        },

        toggleMarkers() {
            // Hiển thị hoặc ẩn các marker dựa trên trạng thái của checkbox
            if (this.showMarkers) {
                // Nếu checkbox được chọn, thêm tất cả các marker vào bản đồ
                this.markers.forEach(marker => {
                    marker.addTo(this.map);
                });
            } else {
                // Nếu checkbox không được chọn, loại bỏ tất cả các marker khỏi bản đồ
                this.markers.forEach(marker => {
                    this.map.removeLayer(marker);
                });
            }
        },
       

        handleCheckboxChange(checkboxName) {
            // Xử lý thay đổi của checkbox dựa trên tên của checkbox
            const isChecked = this[checkboxName];
            console.log("CHECK: ", this[checkboxName]);
            // Thực hiện các hành động tùy thuộc vào tên của checkbox
            if (isChecked) {
                this.markers.forEach(marker => {
                    marker.addTo(this.map);
                });
                // Nếu checkbox được chọn, thực hiện hành động tương ứng
                console.log(`Checkbox ${checkboxName} đã được chọn.`);
            } else {
                this.markers.forEach(marker => {
                    this.map.removeLayer(marker);
                });
                // Nếu checkbox không được chọn, thực hiện hành động tương ứng
                console.log(`Checkbox ${checkboxName} đã bị bỏ chọn.`);
            }
        },


        //popup
        addShapeLayer() {

            // Xây dựng template popup từ template HTML
            const popupTemplate = `
                <div class="custom-popup">
                    <img src='{{ image }}' alt="" />
                    <p>{{ name }}</p>
                </div>
                <div style="display: flex; justify-content: flex-end; margin-right: 20px;">
                    <b-button
                        pill
                        class="fs-13 btn-map"
                        size=""
                        >
                        <i class='bx bx-map-pin'></i>
                        <a href="https://www.google.com/maps/place/{{ googlemap }}" target="_blank">
                            <span class="ps-1">Chỉ đường</span>
                        </a>
                        <!-- <i class="mdi mdi-arrow-right ps-2"></i> -->
                    </b-button>
                </div>
            `;

            const popupTemplateNoImg = `
                <div class="custom-popup-no-img">
                    <p class="custom-popup-center">{{ name }}</p>
                    <p>Người đại diện: <span>{{ DaiDien }}</span></p>
                    <p>Địa chỉ: <span>{{ Address }}</span></p>
                    <p>Số điện thoại: <span>{{ Sdt }}</span></p>
                    <p>Sản phẩm: <span>{{ SanPham }}</span></p>
                </div>
                <div style="display: flex; justify-content: flex-end; margin-right: 20px;">
                    <b-button
                        pill
                        class="fs-13 btn-map"
                        size=""
                        >
                        <i class='bx bx-map-pin'></i>
                        <a href="https://www.google.com/maps/place/{{ googlemap }}"" target="_blank">
                            <span class="ps-1">Chỉ đường</span>
                        </a>
                        <!-- <i class="mdi mdi-arrow-right ps-2"></i> -->
                    </b-button>
                </div>
            `;

            // Định nghĩa hàm để thay thế placeholder trong template
            function compilePopupTemplate(feature) {
                return popupTemplate
                    .replace('{{ name }}', feature.properties.Name)
                    .replace('{{ image }}', feature.properties.Image)
                    .replace('{{ googlemap }}', feature.googlemap )
            }

            function compilePopupTemplateNoImg(feature) {
                return popupTemplateNoImg
                    .replace('{{ name }}', feature.properties.Name)
                    .replace('{{ DaiDien }}', feature.properties.DaiDien)
                    .replace('{{ Address }}', feature.properties.Address)
                    .replace('{{ Sdt }}', feature.properties.Sdt)
                    .replace('{{ SanPham }}', feature.properties.SanPham)
                    .replace('{{ googlemap }}', feature.googlemap )
            }
            // Định nghĩa Icon cho marker
            const customIcon = L.icon({
                iconUrl: require('./marker-icon.png'), // Đường dẫn đến tệp icon
                iconSize: [24], // Kích thước của icon (chiều rộng, chiều cao)
                iconAnchor: [18, 38], // Điểm neo của icon (nằm ở giữa dưới)
                popupAnchor: [0, -32], // Vị trí của popup (nằm ở trên icon)
            });

            const customIcon2 = L.icon({
                iconUrl: require('./icon/marker_doanhnghiep1.png'), // Đường dẫn đến tệp icon
                iconSize: [24], // Kích thước của icon (chiều rộng, chiều cao)
                iconAnchor: [18, 38], // Điểm neo của icon (nằm ở giữa dưới)
                popupAnchor: [0, -32], // Vị trí của popup (nằm ở trên icon)
            });
            const customIcon3 = L.icon({
                iconUrl: require('./icon/marker_doanhnghiep2.png'), // Đường dẫn đến tệp icon
                iconSize: [24], // Kích thước của icon (chiều rộng, chiều cao)
                iconAnchor: [18, 38], // Điểm neo của icon (nằm ở giữa dưới)
                popupAnchor: [0, -32], // Vị trí của popup (nằm ở trên icon)
            });
            const customIcon4 = L.icon({
                iconUrl: require('./icon/marker_doanhnghiep3.png'), // Đường dẫn đến tệp icon
                iconSize: [24], // Kích thước của icon (chiều rộng, chiều cao)
                iconAnchor: [18, 38], // Điểm neo của icon (nằm ở giữa dưới)
                popupAnchor: [0, -32], // Vị trí của popup (nằm ở trên icon)
            });
            const customIcon5 = L.icon({
                iconUrl: require('./icon/marker_doanhnghiep4.png'), // Đường dẫn đến tệp icon
                iconSize: [24], // Kích thước của icon (chiều rộng, chiều cao)
                iconAnchor: [18, 38], // Điểm neo của icon (nằm ở giữa dưới)
                popupAnchor: [0, -32], // Vị trí của popup (nằm ở trên icon)
            });
            const customIcon6 = L.icon({
                iconUrl: require('./icon/marker_doanhnghiep5.png'), // Đường dẫn đến tệp icon
                iconSize: [24], // Kích thước của icon (chiều rộng, chiều cao)
                iconAnchor: [18, 38], // Điểm neo của icon (nằm ở giữa dưới)
                popupAnchor: [0, -32], // Vị trí của popup (nằm ở trên icon)
            });
            const customIcon7 = L.icon({
                iconUrl: require('./icon/marker_doanhnghiep6.png'), // Đường dẫn đến tệp icon
                iconSize: [24], // Kích thước của icon (chiều rộng, chiều cao)
                iconAnchor: [18, 38], // Điểm neo của icon (nằm ở giữa dưới)
                popupAnchor: [0, -32], // Vị trí của popup (nằm ở trên icon)
            });
            const customIcon8 = L.icon({
                iconUrl: require('./icon/marker_doanhnghiep7.png'), // Đường dẫn đến tệp icon
                iconSize: [24], // Kích thước của icon (chiều rộng, chiều cao)
                iconAnchor: [18, 38], // Điểm neo của icon (nằm ở giữa dưới)
                popupAnchor: [0, -32], // Vị trí của popup (nằm ở trên icon)
            });
            const customIcon9 = L.icon({
                iconUrl: require('./icon/camera.png'), // Đường dẫn đến tệp icon
                iconSize: [24], // Kích thước của icon (chiều rộng, chiều cao)
                iconAnchor: [18, 38], // Điểm neo của icon (nằm ở giữa dưới)
                popupAnchor: [0, -32], // Vị trí của popup (nằm ở trên icon)
                smoke: "#fff"
            });

            
            
            // Thêm dữ liệu GeoJSON và xử lý Marker
            L.geoJSON(rankTinh).addTo(this.map);

            L.geoJSON(rankHuyen, {
                onEachFeature: (feature, layer) => {
                    if (feature.properties && feature.properties.Code && feature.properties.Code == "1") {
                        // Thêm lớp CSS cho polygon có code == 1
                        layer.setStyle({ className: 'custom-huyen' });
                    }
                    if (feature.properties && feature.properties.District) {
                        const districtName = feature.properties.District;
                        const center = layer.getBounds().getCenter();
                        L.marker(center, {
                            icon: L.divIcon({
                                className: 'text-label',
                                html: `<p>${districtName}</p>`
                            })
                        }).addTo(this.map);
                    }
                }
            }).addTo(this.map);

            /**************************** MAKER **********************/

            L.geoJSON(shapeData, {
                pointToLayer: (feature, latlng) => {
                    if(
                        feature.properties.Code == "1" || 
                        feature.properties.Code == "1-1" ||
                        feature.properties.Code == "1-2" ||
                        feature.properties.Code == "1-3" ||
                        feature.properties.Code == "1-4"
                    ){
                        // Tạo marker cho từng đối tượng Point trong GeoJSON
                        return L.marker(latlng, { icon: customIcon });
                    }
                    if(feature.properties.Code == "2"){
                        return L.marker(latlng, { icon: customIcon2 });
                    }
                    if(feature.properties.Code == "3"){
                        return L.marker(latlng, { icon: customIcon3 });
                    }
                    if(feature.properties.Code == "4"){
                        return L.marker(latlng, { icon: customIcon4 });
                    }
                    if(feature.properties.Code == "5"){
                        return L.marker(latlng, { icon: customIcon5 });
                    }
                    if(feature.properties.Code == "6"){
                        return L.marker(latlng, { icon: customIcon6 });
                    }
                    if(feature.properties.Code == "7"){
                        return L.marker(latlng, { icon: customIcon7 });
                    }
                    if(feature.properties.Code == "8"){
                        return L.marker(latlng, { icon: customIcon8 });
                    }
                    if(feature.properties.Code == "9"){
                        return L.marker(latlng, { icon: customIcon9 });
                    }
                },
                onEachFeature: (feature, layer) => {
                    if (feature.properties && feature.properties.Code && feature.properties.Code == "9999") {
                        // Thêm lớp CSS cho polygon có code == 9999
                        layer.setStyle({ className: 'custom-point' });
                    }
                    if (feature.properties && feature.properties.Image) {
                        const popupContent = compilePopupTemplate(feature);
                        layer.bindPopup(popupContent);
                    }
                    else{
                        const popupContent = compilePopupTemplateNoImg(feature);
                        layer.bindPopup(popupContent);
                    }
                    layer.on('click', () => {
                        const latlng = layer.getLatLng();
                        // Đặt tâm nhìn bản đồ tới vị trí của marker
                        this.map.setView(latlng);
                        this.showModal = true;
                        this.selectedFeatureName = feature.properties.Name;
                        this.selectedFeatureTitle = feature.properties.Title;
                        this.selectedFeatureDaiDien = feature.properties.DaiDien;
                        this.selectedFeatureAddress = feature.properties.Address;
                        this.selectedFeatureSdt = feature.properties.Sdt;
                        this.selectedFeatureSanPham = feature.properties.SanPham;
                    });
                    layer.on('popupclose', () => {
                        // Đóng modal khi popup được đóng
                        this.closeModal();
                    });
                    // layer.on('popupopen', function() {
                    //     this.map.flyTo(layer.getLatLng(), 13); // 13 là mức zoom mong muốn
                    // });
                }

            }).addTo(this.map);

            /********************************************************/

            /**************************** MAKER TRÒN **********************/
            L.geoJSON(shapeData, {
                pointToLayer: function (feature, latlng) {
                    if (feature.properties.Code == "1") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom custom1'
                            })
                        });
                    }
                    if (feature.properties.Code == "1-1") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom custom1-1'
                            })
                        });
                    }
                    if (feature.properties.Code == "1-2") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom custom1-2'
                            })
                        });
                    }
                    if (feature.properties.Code == "1-3") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom custom1-3'
                            })
                        });
                    }
                    if (feature.properties.Code == "1-4") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom custom1-4'
                            })
                        });
                    }
                    if (feature.properties.Code == "2") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom-new'
                            })
                        });
                    }
                    if (feature.properties.Code == "3") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom-new'
                            })
                        });
                    }
                    if (feature.properties.Code == "4") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom-new'
                            })
                        });
                    }
                    if (feature.properties.Code == "5") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom-new'
                            })
                        });
                    }
                    if (feature.properties.Code == "6") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom-new'
                            })
                        });
                    }
                    if (feature.properties.Code == "7") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom-new'
                            })
                        });
                    }
                    if (feature.properties.Code == "8") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom-new'
                            })
                        });
                    }
                    if (feature.properties.Code == "9") {
                        return L.marker(latlng, {
                            icon: L.divIcon({
                                className: 'custom-new'
                            })
                        });
                    }
                },
                
                onEachFeature: (feature, layer) => {
                    if (feature.properties && feature.properties.Name) {
                        const popupContent = compilePopupTemplate(feature);
                        layer.bindPopup(popupContent);
                    }
                    layer.on('click', () => {
                        const latlng = layer.getLatLng();
                        // Đặt tâm nhìn bản đồ tới vị trí của marker
                        this.map.setView(latlng);
                        this.showModal = true;
                        this.selectedFeatureName = feature.properties.Name;
                        this.selectedFeatureTitle = feature.properties.Title;
                        this.selectedFeatureMota = feature.properties.Mota;
                        this.selectedFeatureDaiDien = feature.properties.DaiDien;
                        this.selectedFeatureAddress = feature.properties.Address;
                        this.selectedFeatureSdt = feature.properties.Sdt;
                        this.selectedFeatureSanPham = feature.properties.SanPham;
                    });
                    layer.on('popupclose', () => {
                        // Đóng modal khi popup được đóng
                        this.closeModal();
                    });
                    // layer.on('popupopen', function() {
                    //     this.map.flyTo(layer.getLatLng(), 13); // 13 là mức zoom mong muốn
                    // });
                }
            }).addTo(this.map);
        },

        /********************************************************/

        closeModal() {
            this.showModal = false;
        }



    }
}
</script>
<template>
    <div>
        <div ref="map" style="height: 650px;">
            <l-popup content="Popup" />
            <img src="@/assets/images/la-co-viet-nam.png" alt="" class="icon-vn">
            <i class='bx bx-reset btn-reset-map' @click="resetMap"></i>
        </div>
        <div class="modal-popup" :class="{ 'is-active': showModal }"
            v-if="selectedFeatureTitle || selectedFeatureDaiDien || selectedFeatureAddress || selectedFeatureSdt || selectedFeatureSanPham || selectedFeatureMota"
        >
            <div class="title-popup">
                <span class="name-content-popup">
                    {{ selectedFeatureName }}
                </span>
                <button class="modal-close is-large" aria-label="close" @click="closeModal">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </button>
            </div>
            <div class="detail-popup">
                <div class="content-popup"
                    v-if="selectedFeatureTitle"
                >
                    <span>
                        {{ selectedFeatureTitle }}
                    </span>
                </div>
                <div class="content-popup mt-3"
                    v-if="selectedFeatureDaiDien && selectedFeatureAddress && selectedFeatureSdt && selectedFeatureSanPham"
                >
                    <p v-if="selectedFeatureDaiDien">
                        <i class='bx bx-user icon-bx'></i>
                        <span>
                            Người đại diện: {{ selectedFeatureDaiDien }}
                        </span>
                    </p>
                    <p v-if="selectedFeatureAddress">
                        <i class='bx bx-map-pin icon-bx'></i>
                        <span>
                            Địa chỉ: {{ selectedFeatureAddress }}
                        </span>
                    </p>
                    <p v-if="selectedFeatureSdt">
                        <i class='bx bx-phone-call icon-bx'></i>
                        <span>
                            Số điện thoại: {{ selectedFeatureSdt }}
                        </span>
                    </p>
                    <p v-if="selectedFeatureSanPham">
                        <i class='bx bx-food-menu icon-bx'></i>
                        <span>
                            Sản phẩm: {{ selectedFeatureSanPham }}
                        </span>
                    </p>
                </div>
                <div class="mt-3">
                    <b-button
                        pill
                        class="fs-13 btn-map-mobi"
                        size=""
                        >
                        <i class='bx bx-map-pin'></i>
                        <span class="ps-1">Chỉ đường</span>
                        <!-- <i class="mdi mdi-arrow-right ps-2"></i> -->
                    </b-button>
                </div>
                <!-- <div class="modal-content">
                    <p><strong>Name:</strong> {{ selectedFeatureName }}</p>
                    <p><strong>Other details:</strong> {{ selectedFeatureDetails }}</p>
                </div> -->
                <div class="content-popup-name"
                    v-if="selectedFeatureMota"
                >
                    <span>
                        THÔNG TIN
                    </span>
                </div>
                <div class="content-popup"
                    v-if="selectedFeatureMota"
                >
                    {{ selectedFeatureMota }}
                </div>
            </div>
        </div>

        <div class="panel-bando">
            <div class="panel-one">
                <div class="panel-main">
                    <div class="panel-title">
                        <div class="logo-panel">
                            <img src="@/assets/images/5.png" alt="">
                        </div>
                        <div class="name">
                            <p class="name1">Bản đồ số sen</p>
                            <p class="name2">Tỉnh Đồng Tháp</p>
                        </div>
                    </div>
                </div>
                <div class="panel-section">
                    <!-- <div class="title">
                        <i class='bx bx-star'></i>
                        <span>Thông tin bản đồ</span>
                        <i class='bx bx-star'></i>
                    </div> -->
                    <ul class="card-icon">
                        <li class="item">
                            <span class="icon">
                                <div class="vung-trong"></div>
                            </span>
                            <span class="card-icon-name">Vùng trồng sen</span>
                            <!-- <input type="checkbox" class="check" v-model="checkbox1" @change="handleCheckboxChange('checkbox1')"> -->
                        </li>
                        <li class="item">
                            <span class="icon">
                                <img src="@/assets/images/icon/marker_doanhnghiep1.png" alt="">
                            </span>
                            <span class="card-icon-name">Chế biến</span>
                            <!-- <input type="checkbox" class="check" v-model="checkbox2" @change="handleCheckboxChange('checkbox2')"> -->
                        </li>
                        <li class="item">
                            <span class="icon">
                                <img src="@/assets/images/icon/marker_doanhnghiep2.png" alt="">
                            </span>
                            <span class="card-icon-name">Kinh doanh</span>
                            <!-- <input type="checkbox" class="check" v-model="checkbox3" @change="handleCheckboxChange('checkbox3')"> -->
                        </li>
                        <li class="item">
                            <span class="icon">
                                <img src="@/assets/images/icon/marker_doanhnghiep3.png" alt="">
                            </span>
                            <span class="card-icon-name">Sản xuất</span>
                            <!-- <input type="checkbox" class="check" v-model="checkbox4" @change="handleCheckboxChange('checkbox4')"> -->
                        </li>
                        <li class="item">
                            <span class="icon">
                                <img src="@/assets/images/icon/marker_doanhnghiep4.png" alt="">
                            </span>
                            <span class="card-icon-name">Sơ chế</span>
                            <!-- <input type="checkbox" class="check" v-model="checkbox5" @change="handleCheckboxChange('checkbox5')"> -->
                        </li>
                        <li class="item">
                            <span class="icon">
                                <img src="@/assets/images/icon/marker_doanhnghiep5.png" alt="">
                            </span>
                            <span class="card-icon-name">Thu gom</span>
                            <!-- <input type="checkbox" class="check" v-model="checkbox6" @change="handleCheckboxChange('checkbox6')"> -->
                        </li>
                        <li class="item">
                            <span class="icon">
                                <img src="@/assets/images/icon/marker_doanhnghiep6.png" alt="">
                            </span>
                            <span class="card-icon-name">Thu mua, sơ chế</span>
                            <!-- <input type="checkbox" class="check" v-model="checkbox7" @change="handleCheckboxChange('checkbox7')"> -->
                        </li>
                        <li class="item">
                            <span class="icon">
                                <img src="@/assets/images/icon/marker_doanhnghiep7.png" alt="">
                            </span>
                            <span class="card-icon-name">Điểm trồng sen</span>
                            <!-- <input type="checkbox" class="check" v-model="checkbox8" @change="handleCheckboxChange('checkbox8')"> -->
                        </li>
                        <li class="item">
                            <span class="icon">
                                <img src="@/assets/images/icon/camera.png" alt="" class="img-camera">
                            </span>
                            <span class="card-icon-name">Địa điểm du lịch</span>
                            <!-- <input type="checkbox" class="check" v-model="checkbox9" @change="handleCheckboxChange('checkbox9')"> -->
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.content-popup {
    border: 1px solid #ddd;
    border-radius: 15px;
    border-top: 3px solid #ec008b;
    padding: 15px;
    text-align: justify;
}
.content-popup p{
    color: #000;
}

.content-popup-name{
    text-align: center;
    font-weight: bold;
    color: #ec008b;
    font-size: clamp(0.625rem, 0.4018rem + 0.7143vw, 0.9375rem);
}
.icon-bx{
    font-size: 16px;
    color: #ec008b;
    margin-right: 5px;
}

.detail-popup {
    padding: 10px;
    overflow: scroll;
    overflow-x: hidden;
    height: 608px;
}
</style>

<style>
/* Định dạng CSS tùy chỉnh cho marker */
.marker-icon {
    background-image: url('./marker-icon.png');
    background-size: contain;
    width: 32px;
    height: 32px;
}

.icon-vn {
    position: absolute;
    z-index: 9999;
    width: 30px;
    right: 0;
    bottom: 0;
}

.leaflet-control-attribution a {
    display: none !important;
}

.leaflet-pane>svg path.leaflet-interactive {
    position: relative !important;
    height: 50px !important;
}

.leaflet-popup {
    left: -182px !important;
}

.custom{
    width: 50px !important;
    height: 50px !important;
    background-color: #3287cc;
    border: none;
    border-radius: 50%;
    /* Để làm cho nó trở thành hình tròn */
    margin-left: -32px !important;
    margin-top: -60px !important;
    border: 3px solid #ec008b !important;
    background-repeat: no-repeat;
    background-size: cover;
}

.custom1 {
    background-image: url("../assets/images/marker-tron/1.jpg");
}
.custom1-1 {
    background-image: url("../assets/images/marker-tron/2.jpg");
}
.custom1-2 {
    background-image: url("../assets/images/marker-tron/3.jpg");
}
.custom1-3 {
    background-image: url("../assets/images/marker-tron/4.jpg");
}
.custom1-4 {
    background-image: url("../assets/images/marker-tron/5.jpg");
}

.custom-new {
    width: 0px !important;
    height: 0px !important;
}

.custom-huyen{
    stroke: #49ec69;
    stroke-width: 1;
    fill-opacity: 0.9;
    fill: #d8266e;
}

.leaflet-container{
    background-color: #ff000038;
}

.custom-point{
    stroke: #000 !important;
    fill-opacity: 0.9;
    fill: #fff;
}

.custom-popup-no-img{
    top: -180px;
}

.leaflet-popup-content-wrapper {
    width: 350px !important;
}

.leaflet-popup-content {
    width: auto !important;
    margin: 0px !important;
}

.custom-popup, .custom-popup-no-img {
    padding: 15px;
}

.custom-popup img {
    width: 100%;
    border-radius: 12px;
}

.custom-popup p {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #ec008b;
    margin: 5px;
}

.custom-popup-no-img p{
    margin: 5px;
    font-weight: bold;
    color: #000;
}
.custom-popup-no-img p span{
    color: #ec008b;
}
.custom-popup-no-img .custom-popup-center{
    color: #ec008b;
    text-align: center;
    text-transform: uppercase
}

.modal-popup {
    display: none;
    position: absolute;
    top: 0;
    right: 0 !important;
    bottom: 0;
    width: 30%;
    /* Điều chỉnh kích thước modal tùy thích */
    background-color: white;
    z-index: 111;
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
}

.modal-content {
    padding: 20px;
}

.is-active {
    display: block;
}

.modal-close {
    background-color: inherit;
    border: none;
    color: #fff;
}

.title-popup {
    display: flex;
    justify-content: space-between;
    background-color: #ec008b;
    padding: 10px;
    color: #fff;
    font-weight: bold;
}

.text-label {
    width: 140px !important;
    margin-left: -40px !important;
    color: #fff;
    font-family: 'Montserrat';
}

.panel-bando{
    display: block;
    /* position: absolute; */
    left: 12px;
    bottom: 0;
    /* width: 250px; */
    /* Điều chỉnh kích thước modal tùy thích */
    /* background-color: #ebffda; */
    background-color: #dbf4c6;
    z-index: 99;
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);

}

/* .panel::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    right: -15px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 15px 0 0;
    border-color: rgba(0,0,0,0) #a3bb8f  rgba(0,0,0,0) rgba(0,0,0,0);
} */

/* .panel::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: -15px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 15px 0 0;
    border-color: rgba(0,0,0,0) #a3bb8f  rgba(0,0,0,0) rgba(0,0,0,0);
} */

.panel-bando .panel-one{
    position: relative;
}

/* .panel-main{
    padding: 10px;
} */

.panel-title{
    display: flex;
    justify-content: center;
    align-items: center;
}

.panel-title .logo-panel{
    text-align: center;
}

.panel-title .logo-panel img{
    width: 50px;
}

.panel-title .name p{
    font-weight: bold;
    text-transform: uppercase;
    margin: 0;
    text-align: center;
}

.panel-title .name1{
    font-size: clamp(0.625rem, 0.5357rem + 0.2857vw, 0.75rem);
    color: #51a04b;
}

.panel-title .name2{
    font-size: clamp(0.625rem, 0.4464rem + 0.5714vw, 0.875rem);
    color: #d8266e;
}

.panel-section .title{
    font-size: clamp(0.625rem, 0.5357rem + 0.2857vw, 0.75rem);
    color: #d8266e;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    padding: 10px;
}

.panel-section .title span{
    margin: 0 10px;
}

.panel-section .card-icon{
    padding: 10px;
    grid-gap: 5px 15px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    list-style: none;
}

.panel-section .card-icon .card-card{
    display: flex;
    justify-content: center;
    align-items: center;
}

.panel-section .card-icon .item{
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-around;
    padding: 0;
}

.panel-section .card-icon .item .icon{
    height: 27px;
    display: flex;
    align-items: center;
}

.panel-section .card-icon .item .icon .vung-trong{
    width: 18px;
    height: 18px;
    background-color: #e5e8fc;
    border: 2px solid #3388ff;
}

.panel-section .card-icon .icon img{
    width: 100%;
    height: 100%;
}
.panel-section .card-icon .icon .img-camera{
    width: 20px !important;
    height: 20px !important;
}

.panel-section .card-icon .item .card-icon-name{
    width: 70%;
    color: #000;
    font-weight: bold;
    font-size: clamp(0.625rem, 0.4018rem + 0.7143vw, 0.9375rem);
}

.panel-section .card-icon .card-card .card-title{
    color: #000;
    font-size: clamp(0.625rem, 0.4018rem + 0.7143vw, 0.9375rem);
}

.leaflet-top{
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.leaflet-left .leaflet-control{
    margin-left: 0px !important;
    margin-right: 10px;
}

.name-content-popup{
    font-size: clamp(0.625rem, 0.4018rem + 0.7143vw, 0.9375rem);
    display: flex;
    align-items: center;
}


@media only screen and (max-width: 576px) {
  .panel-bando{
    position: static;
    width: 100%;
  }
  .panel-section .card-icon{
    grid-template-columns: 1fr 1fr;
    margin-bottom: 0px;
  }
  .leaflet-container{
    height: 500px !important;
  }
  .modal-popup{
    width: 90% !important;
    height: 250px;
    right: 19px !important;
    top: 250px;
  }
  .leaflet-popup{
    display: none;
  }
    .panel-section .card-icon .icon img{
        width: 21px;
        height: 30px;
    }
    .detail-popup{
        height: 200px !important;
    }
    .btn-map-mobi{
        display: block !important;
    }
}

@media only screen and (max-width: 800px) {
    .modal-popup{
        width: 40%;
    }
}


.btn-map{
    border: 2px solid #51a04b !important;
    background-color: #fff !important;
    color: #51a04b !important;
    border: none;
    border-radius: 5px;
    padding: 5px;
    margin-bottom: 10px !important;
    cursor: pointer;
}

.btn-map a{
    color: #51a04b !important;
}

.btn-map-mobi{
    border: 2px solid #51a04b !important;
    background-color: #fff !important;
    color: #51a04b !important;
    border: none;
    border-radius: 5px;
    padding: 5px;
    margin-bottom: 10px !important;
    cursor: pointer;
    display: none;
    margin-right: 20px;
}

.btn-reset-map{
    position: absolute;
    right: 30px;
    bottom: 30px;
    font-size: 30px;
    color: #000;
    z-index: 1111;
    
}

/********************CUSTOM SCROLLBAR **********************/

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  background: #ec008b;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #ccc;
  border-radius: 0px;
}
</style>